import { scopedKey } from "@/queries/scope";
import { observedRead, type THintTargets } from "./types";

/** The programs domain's hint rows (NG-2800). */
export const PROGRAMS_HINTS: THintTargets = {
  // Every cached program read in the workspace: the lists, the pickers' banks,
  // each program's detail and its linked projects and requests, all keyed
  // under `programs`.
  "programs:bank": observedRead((scope) => scopedKey(scope, "programs")),
};
